import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
import GoogleAuth from 'vue-google-oauth'
import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.use(GoogleAuth, { client_id: "169916085440-me7etn8et7g4nu40gpb28glh8j2vc0lj.apps.googleusercontent.com" })
Vue.googleAuth().load()
Vue.use(VueClipboard) 
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.config.productionTip = false

import Axios from 'axios'
Axios.defaults.baseURL = "https://greenfam.herokuapp.com/"
// Axios.defaults.baseURL = "http://localhost:8085/" 

Vue.prototype.$http = Axios;
const token = localStorage.getItem('token'); 
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

new Vue({
  created(){
    AOS.init()
  },
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
